/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/prefer-relative-imports */

'use es6';

import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { List } from 'immutable';
import styled from 'styled-components';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import NewMessagesAlert from 'conversations-thread-view/alerts/components/NewMessagesAlert';
import { STARTED } from 'conversations-async-data/async-data/constants/asyncStatuses';
import { isCommonMessageFormat } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import ScrollWrapper from '../scrolling/components/ScrollWrapper';
import { withScrollTo } from '../scrolling/components/withScrollTo';
import { getSenderId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getQueryParams, getMessageIdFromLocation } from 'conversations-inbox-message-history/url/queryParamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  children: PropTypes.node.isRequired,
  currentUserId: PropTypes.number.isRequired,
  fetchOlderHistory: PropTypes.func.isRequired,
  messages: PropTypes.instanceOf(List),
  persistedMessageCount: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};
const LoadingDotsWrapper = styled.div.withConfig({
  displayName: "ThreadHistoryScrollWrapper__LoadingDotsWrapper",
  componentId: "raced4-0"
})(["height:0;margin-top:12px;"]);
const ScrollToWrapper = withScrollTo(ScrollWrapper);
class ThreadHistoryScrollWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.onScrollFromBottom = () => {
      const messages = this.props.messages;
      const latestMessage = messages && messages.last();
      const latestTimestamp = latestMessage && latestMessage.get('timestamp');
      this.setState({
        latestMessageTimestamp: latestTimestamp,
        shouldCountNewMessages: true
      });
    };
    this.onScrollToBottom = () => {
      this.setState({
        newMessageCount: 0,
        shouldCountNewMessages: false
      });
    };
    this.sendScrollToBottom = () => {
      const {
        current
      } = this.scrollWrapper;
      if (current) current.scrollToBottom();
    };
    this.hideNewMessageAlert = () => {
      this.setState({
        showNewMessageAlert: false
      });
    };
    this.scrollWrapper = /*#__PURE__*/createRef();
    this.state = {
      latestMessageTimestamp: null,
      newMessageCount: 0,
      shouldCountNewMessages: false,
      showNewMessageAlert: false
    };
  }
  componentWillUnmount() {
    /**
     * This redirect removes the messageId query param from the URL.
     * We access the current location from this.props.history.location
     * rather than from this.props.location because this.props.location
     * only updates according to the react lifecycle, while
     * this.props.history.location updates immediately as the history
     * object is mutable. This prevents the location from being stale.
     *
     * See this PR for details:
     * https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3789
     */
    const urlParams = getQueryParams(this.props.history.location);
    if (urlParams && urlParams.has('messageId')) {
      urlParams.delete('messageId');
      this.props.history.replace({
        search: urlParams.toString()
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      persistedMessageCount: prevPersistedMessageCount
    } = prevProps;
    const {
      currentUserId,
      persistedMessageCount,
      messages
    } = this.props;
    const {
      shouldCountNewMessages,
      newMessageCount,
      latestMessageTimestamp
    } = this.state;
    if (shouldCountNewMessages) {
      const newMessages = messages && messages.filter(message => {
        const senderId = getSenderId(message);
        return message.get('timestamp') > latestMessageTimestamp && senderId !== currentUserId && isCommonMessageFormat(message);
      });
      if (newMessageCount !== newMessages.size) {
        this.setState({
          newMessageCount: newMessages.size,
          showNewMessageAlert: true
        });
      }
    }
    if (persistedMessageCount !== prevPersistedMessageCount) {
      const {
        current
      } = this.scrollWrapper;
      if (current) current.scrollToBottomIfInThreshold();
    }
  }
  render() {
    const {
      children,
      fetchOlderHistory,
      status
    } = this.props;
    const {
      newMessageCount,
      showNewMessageAlert
    } = this.state;
    return /*#__PURE__*/_jsxs(ScrollToWrapper, {
      className: "ThreadHistoryScrollWrapper",
      ref: this.scrollWrapper,
      onScrollToTop: fetchOlderHistory,
      onScrollToBottom: this.onScrollToBottom,
      onScrollFromBottom: this.onScrollFromBottom,
      scrollToMessageId: getMessageIdFromLocation(this.props.location),
      children: [newMessageCount > 0 && showNewMessageAlert ? /*#__PURE__*/_jsx(NewMessagesAlert, {
        newMessageCount: newMessageCount,
        onClickViewMessages: this.sendScrollToBottom,
        onClose: this.hideNewMessageAlert
      }) : null, /*#__PURE__*/_jsx(LoadingDotsWrapper, {
        children: status === STARTED && /*#__PURE__*/_jsx(UILoadingSpinner, {
          style: {
            height: 0,
            marginTop: 8
          },
          grow: true
        })
      }), children]
    });
  }
}
ThreadHistoryScrollWrapper.propTypes = propTypes;
ThreadHistoryScrollWrapper.displayName = 'ThreadHistoryScrollWrapper';
export default withRouter(ThreadHistoryScrollWrapper);

// For unit testing only
export const UnwrappedThreadHistoryScrollWrapper = ThreadHistoryScrollWrapper;